/* Quickbooks module */

import uiRouter from '@uirouter/angularjs';

import { AppShellModule } from 'components/appShell/appShell.module';
import { AppsServiceModule } from '../../services/data/apps.service';


import './quickbooks.scss';

export const QuickbooksModule = angular
    .module('app.pages.quickbooks', [
        uiRouter,
        AppShellModule,
        AppsServiceModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state({
            parent: 'apps',
            name: 'quickbooks',
            url: '/quickbooks',
            component: 'appShell',
            params: {
                queryString: null
            },
            resolve: {
                title: () => 'Quickbooks',
                trackingId: () => 'Quickbooks',
                src: (appsService, authTokenService, $q, $stateParams) => {
                    return $q.all([
                        appsService.getApps(),
                        appsService.getAppToken('w5JXLS5vDLQkgdjsPvZNC1dU2HZ2S3YgTYu4N5gq9Gjc8W1fCvZWVYdcBDW_hryJw5vaE2AsOcj9KxB7Iowz6A'), // eslint-disable-line max-len
                        authTokenService.getTenantId()
                    ])
                        .then(([apps, token, tenant]) => {
                            let uri = '';
                            apps.forEach((app) => {
                                if (app.sku === 'quickbooks') {
                                    uri = `${app.uri}?orgid=${tenant}&token=${token}&keyname=quickbooksonline`; //eslint-disable-line
                                    if ($stateParams.queryString) {
                                        uri = `${uri}&${$stateParams.queryString}`;
                                    }
                                }
                            });
                            return uri;
                        });
                }
            },
            data: {
                page: 'quickbooks'
            }
        });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/quickbooks/quickbooks.module.js